// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Oe","innerTile":"Pe","heading":"Qe","instaTileBtn":"Re","disabled":"Se","instaTileElement":"Te","instagramPic":"Ue"};